import React from 'react';
import { reactUrlToBrowserUrl } from '../../../../urlParse';
import Basepage, { BasePageState } from '../Basepage';
import BestsellerViewer from '../Basepage/parts/BestsellerViewer';
import MolLink from '../Basepage/parts/Menu/MolLink';
import ProductCarousel from '../Basepage/parts/ProductCarousel';
import { ProductCarouselModel } from '../Basepage/parts/ProductCarousel/Model';

import './index.scss';

import Banner from './Parts/Banner';

interface StartPageState extends BasePageState {}

interface StartPageModel {
  bannerConfig: any;
  features: any;
  spiegel_HCBelle: ProductCarouselModel[];
  spiegel_HoerbuchKinder: ProductCarouselModel[];
}

export default class StartPage extends Basepage<
  StartPageState,
  StartPageModel
> {
  renderChild(): JSX.Element {
    return (
      <div id="startPage">
        {/* 
        <Banner config={this.body.bannerConfig} />
        */}
        <div id="caruselWraper">
          <ProductCarousel
            items={this.body.features}
            title="Unsere Empfehlungen"
            titlePosition="center"
            showTitle={true}
          ></ProductCarousel>
        </div>

        <div className="bestsellerContainer">
          <div className="bestsellerWrapper">
            <BestsellerViewer
              items={this.body.spiegel_HCBelle}
              title="Buch-Bestseller"
              allLink="/search_page/?fqZZZListe=Spiegel%20Bestseller%20Hardcover%20Belletristik"
            ></BestsellerViewer>
          </div>
          <div className="bestsellerWrapper">
            <BestsellerViewer
              items={this.body.spiegel_HoerbuchKinder}
              title="Hörbuch-Bestseller"
              allLink="/search_page/?fqZZZListe=Spiegel%20Bestseller%20H%C3%B6rb%C3%BCcher%20Kinder"
            ></BestsellerViewer>
          </div>
        </div>

        <div className="wrapper">
          <div className="gallerybutton">
            <div className="inside">
              {this.buildListBoxItem(
                '/search_page/?fqZZZKategorie=Musik',
                '../layout/icon-musik.svg',
                'Musik',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZHauptwarengruppe=kinderbuch%20und%20jugendbuch&fqZZZKategorie=buch&fqZZZSprache=deutsch',
                '../layout/icon-buecher.svg',
                'Kinder- und Jugendbücher',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZKategorie=buch&fqZZZWarengruppe=essen%20und%20trinken',
                '../layout/icon-kochbuecher.svg',
                'Kochbücher',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZBuchtyp=H%C3%B6rbuch',
                '../layout/icon-hoerbuecher.svg',
                'Hörbücher',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZDetailwarengruppe=krimi___kriminalromane&fqZZZKategorie=buch&fqZZZSprache=deutsch',
                '../layout/icon-krimi.svg',
                'Krimi',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZSerie=puzzle',
                '../layout/icon-puzzle.svg',
                'Puzzles',
              )}
              {this.buildListBoxItem(
                '/search_page/?fqZZZKategorie=Film',
                '../layout/icon-filme.svg',
                'Filme',
              )}
            </div>
          </div>
        </div>
        <div id="logo-element">
          <div className="inside">
            <MolLink
              to="/search_page/?fqZZZSchlagwort=Tonies"
              href="Schlagwort/Tonies/s/"
              title="Tonies Hörfiguren"
            >
              <img src="../layout/marke_tonies.jpg" alt="Tonies" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZListe=Ravensburger"
              href="Liste/Ravensburger/s/"
              title="Ravensburger Bücher und Spiele"
            >
              <img src="../layout/marke-ravensburger.jpg" alt="Ravensburger" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZListe=Spiegel%20Bestseller%20Hardcover%20Belletristik"
              href="Liste/Spiegel%20Bestseller%20Hardcover%20Belletristik/s/"
              title="Spiegel Bestseller"
            >
              <img
                src="../layout/marke-spiegel-bestseller.jpg"
                alt="Spiegel-Bestseller"
              />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZSerie=Was%20ist%20was"
              href="Serie/Was%20ist%20was/s/"
              title="Serie/Was%20ist%20was/s/"
            >
              <img src="../layout/marke_wasistwas.jpg" alt="WAS IST WAS" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZHersteller=Edding"
              href="Hersteller/Edding/s/"
              title="Edding Stifte"
            >
              <img src="../layout/marke_edding.png" alt="Edding" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZVerlag=kosmos%20spiele&keyword=kosmos%20exit"
              href="Verlag/kosmos%20spiele/s/?keyword=kosmos%20exit"
              title="Kosmos Exit Escape Games"
            >
              <img
                src="../layout/marke_exit_kosmos.jpg"
                alt="Exit Games von Kosmos"
              />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZVerlag=Moleskine"
              href="Verlag/Moleskine/s/"
              title="Moleskine Notizbücher"
            >
              <img src="../layout/marke-m.jpg" alt="Moleskine" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZHersteller=Nici%20Gmbh"
              href="Hersteller/Nici%20Gmbh/s/"
              title="Nici"
            >
              <img src="../layout/nici_logo.jpg" alt="Nici" />
            </MolLink>
            <MolLink
              to="/search_page/?fqZZZHersteller=LEGO%20%C2%AE"
              href="Hersteller/LEGO%20%C2%AE/s/"
              title="LEGO"
            >
              <img src="../layout/marke-lego.jpg" alt="LEGO" />
            </MolLink>
          </div>
        </div>
        <div id="luna-element">
          <img
            id="luna-grafik"
            src="../layout/luna-grafik.png"
            alt="Luna"
            title="Luna"
          />
          <span className="luna-headline">Alle Mangas versandkostenfrei!</span>
          <span className="luna-subline">
            Starke Angebote &amp; bester Service bei deinem Manga und Anime
            Dealer.
          </span>
          <div className="luna-link">
            <MolLink
              to="/search_page/?fqZZZKategorie=buch&fqZZZSchlagwort=manga&fqZZZSprache=deutsch"
              href="/Kategorie/buch/Schlagwort/manga/Sprache/deutsch/s/"
              title="zu unseren Mangas"
            >
              zu den Mangas
            </MolLink>
          </div>
        </div>
      </div>
    );
  }

  buildListBoxItem(reactLink: string, icon: any, text: string) {
    let broserLink = reactUrlToBrowserUrl(reactLink, null, null);
    return (
      <div className="link-box">
        <div className="flex-bild">
          <MolLink to={reactLink} href={broserLink}>
            <img alt={text} src={icon} />
          </MolLink>
        </div>
        <div className="flex-link">
          <MolLink to={reactLink} href={broserLink}>
            {text}
          </MolLink>
        </div>
      </div>
    );
  }

  initState(base: BasePageState): StartPageState {
    let newState: StartPageState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(): string {
    return this.state.apiBase + '/index.php?frame=api&main_page=start';
  }
  childDidMount(): void {}
  childDidUnmount(): void {}

  initJSChild(): string {
    let initjs = '';

    return initjs;
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return null;
  }

  pageHeaderGetter(): string {
    return '';
  }
  pageTitleGetter(): string {
    return '';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Startpage</span>;
  }
  getType(): string {
    return 'StartPage';
  }
}
